import React, { useRef, useState } from "react"
import { Icon, Tooltip } from "@silversea-ssc/ui-components-react"
import clsx from "clsx"
import { i18n } from "@lingui/core"
import styles from "./GuaranteedSuiteInfo.module.scss"
import getGuaranteedSuiteInfoContent from "./content"

type CruiseLabelGuaranteedSuiteProps = {
    label?: string
    className?: string
}

const GuaranteedSuiteInfo: React.FC<CruiseLabelGuaranteedSuiteProps> = ({ label, className }) => {
    const referenceElement = useRef<HTMLElement>(null)
    const [showTooltip, setShowTooltip] = useState(false)
    const onClick = () => setShowTooltip((x) => !x)
    const onClose = () => setShowTooltip(false)
    const guaranteedSuiteInfoContent = getGuaranteedSuiteInfoContent()
    const labelOrFallback = label || guaranteedSuiteInfoContent.label

    return (
        <React.Fragment>
            <button
                className={clsx(styles.button, className, { [styles.showTooltip]: showTooltip })}
                onClick={onClick}
                onKeyDown={onClick}
                data-content-piece="garanteed_open_tooltip"
            >
                {i18n._(labelOrFallback)}
                <span className={styles.icon} ref={referenceElement}>
                    <Icon name={"info"} padding={false} />
                </span>
            </button>
            <Tooltip referenceElement={referenceElement} onClose={onClose} show={showTooltip} width={200}>
                {i18n._(guaranteedSuiteInfoContent.tooltipDetails)}
            </Tooltip>
        </React.Fragment>
    )
}

export default GuaranteedSuiteInfo
